/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Telegram_Mock_Status_ApprovedInputs */

const tr_landing_telegram_mock_status_approved = /** @type {(inputs: Landing_Telegram_Mock_Status_ApprovedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sipariş onaylandı`)
};

const en_landing_telegram_mock_status_approved = /** @type {(inputs: Landing_Telegram_Mock_Status_ApprovedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Order approved`)
};

const de_landing_telegram_mock_status_approved = /** @type {(inputs: Landing_Telegram_Mock_Status_ApprovedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bestellung bestätigt`)
};

const ru_landing_telegram_mock_status_approved = /** @type {(inputs: Landing_Telegram_Mock_Status_ApprovedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Заказ подтверждён`)
};

/**
* | output |
* | --- |
* | "Order approved" |
*
* @param {Landing_Telegram_Mock_Status_ApprovedInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const landing_telegram_mock_status_approved = /** @type {((inputs?: Landing_Telegram_Mock_Status_ApprovedInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Telegram_Mock_Status_ApprovedInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_telegram_mock_status_approved(inputs)
	if (locale === "de") return de_landing_telegram_mock_status_approved(inputs)
	if (locale === "ru") return ru_landing_telegram_mock_status_approved(inputs)
	return tr_landing_telegram_mock_status_approved(inputs)
});